import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Today from '../../components/Today';

export default function TodayPage() {
  const ctx = useOutletContext();
  return <Today {...ctx} />;
}
